import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-generic',
  templateUrl: './generic.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class GenericComponent implements OnInit {

  @Input() entity : string;

  constructor(private bsModalRef : BsModalRef) { }

  ngOnInit(): void {
  }

  cancel(){
    this.bsModalRef.hide();
  }

}
